import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import CategoryGrid from "./components/CategoryGrid";
import WhatIsSection from "./components/WhatIsSection";
import FeatureCards from "./components/FeatureCards";
import TrustSection from "./components/TrustSection";
import ComparisonTable from "./components/ComparisonTable";
import ArticlePreview from "./components/ArticlePreview";
import { generateOrganizationJsonLd, generateBreadcrumbJsonLd } from "@/utils/seo-schema";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <WhatIsSection />
        <FeatureCards />
        <TrustSection />
        <ComparisonTable />
        <ArticlePreview />
      </main>
      <Footer />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: generateBreadcrumbJsonLd([{ name: "Strona główna", path: "/" }]),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: generateOrganizationJsonLd(),
        }}
      />
    </div>
  );
}